import { useEffect } from 'react';

import { SHIPPING_CONFIDENCE_EXPERIMENT } from './constants';
import { isShippingConfidenceAtRisk } from './helpers/isShippingConfidenceAtRisk';

import { useExperiments } from '@/modules/experiments/useExperiments';
import { useProductBySlugExtendedPDP } from '@/modules/product/hooks/useProductBySlugExtendedPDP';

/**
 * Deferred activation for the low-shipping-confidence PDP friction experiment (Ghost Seller Busters). Exposure must
 * equal eligible impressions, so a bucketing decision is requested only once
 * the extended payload resolves with an at-risk `shipping_confidence` band -
 * control users included, so the comparison holds.
 *
 * Reading the returned decision never triggers bucketing (the hook is
 * deferred), so consumers can call this freely; repeated `bucket()` calls
 * are deduped by the experiments cache.
 */
export function useShippingConfidenceDecision() {
  const { data: productExtended } = useProductBySlugExtendedPDP();

  const isEligible = isShippingConfidenceAtRisk(
    productExtended?.shipping_confidence?.level
  );

  const [decisions, bucket] = useExperiments([SHIPPING_CONFIDENCE_EXPERIMENT], {
    deferred: true,
  });

  useEffect(() => {
    if (isEligible) {
      bucket();
    }
  }, [isEligible, bucket]);

  return {
    isEligible,
    decision: decisions[SHIPPING_CONFIDENCE_EXPERIMENT],
  };
}
